'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'sun-bright';
var width = 512;
var height = 512;
var aliases = ["sun-alt"];
var unicode = 'e28f';
var svgPathData = ['M160 256a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z', 'M248 512l0-104 16 0 0 104-16 0zm0-408l0-104 16 0 0 104-16 0zM69.3 431.4l5.7-5.7 62.2-62.2 5.7-5.7 11.3 11.3-5.7 5.7-62.2 62.2-5.7 5.7-11.3-11.3zM357.8 142.9l5.7-5.7 62.2-62.2 5.7-5.7 11.3 11.3-5.7 5.7-62.2 62.2-5.7 5.7-11.3-11.3zM504 264l-96 0 0-16 104 0 0 16-8 0zM96 264l-96 0 0-16 104 0 0 16-8 0zM431.4 442.7l-5.7-5.7-62.2-62.2-5.7-5.7 11.3-11.3 5.7 5.7 62.2 62.2 5.7 5.7-11.3 11.3zM142.9 154.2l-73.5-73.5 11.3-11.3 73.5 73.5-11.3 11.3zM352 256a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-208 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSunBright = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;